import { AnchorButton, Collapse, Divider, H5, Icon } from '@blueprintjs/core'
import * as React from 'react'
import { UprightStyle } from '../../types'

export interface Props {
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  isOpen: boolean
  title: string
  children: React.ReactNode
  tag?: React.ReactNode
  onClear?: () => void
  clearDisabled?: boolean
}

const style: UprightStyle = {
  tag: { padding: `0 20px`, marginBottom: 10 },
  divider: { margin: `20px 0 0 0` },
  clearBtn: { marginTop: 20 },
  divContainer: { padding: `0 20px` }
}

const FilterBlock: React.FC<Props> = ({ onClick, title, isOpen, children, tag, onClear, clearDisabled = false }) => {
  return (
    <>
      <div className="order-drawer-heading" onClick={onClick}>
        <H5>{title}</H5>
        <Icon icon={isOpen ? 'caret-up' : 'caret-down'} />
      </div>

      <Collapse isOpen={isOpen}>
        <div style={style.divContainer}>
          {children}
          {onClear && (
            <AnchorButton onClick={onClear} disabled={clearDisabled} style={style.clearBtn}>
              Clear
            </AnchorButton>
          )}
          <Divider style={style.divider} />
        </div>
      </Collapse>
      {tag && !isOpen && <div style={style.tag}>{tag}</div>}
    </>
  )
}

export default FilterBlock
